export default __webpack_public_path__ + "static/media/nissan_juke_fog.960e7da0.jpg";